import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import Button from 'react-bootstrap/lib/Button';
import { defaultMessages } from '../../../libs/i18n/default'
import { setPreviousPage, setNextPage } from '../../../shared/actions'
import TrackableButton from './TrackableButton'

const ButtonGroup = ({ intl: { formatMessage }, disableSubmit, submitFunc, back, skip, page }) => {
  const [pressed, setPressed] = useState(false)
  const user = useSelector(state => state.user)
  const dispatch = useDispatch()
  const icon = () => (
    pressed
    ? <i className="fa fa-fw fa-spinner fa-spin" />
    : formatMessage(defaultMessages.clientCommonButtonsContinue)
  )

  const submitClick = (e) => {
    setPressed(true)
    submitFunc(e)
  }

  const dummyButton = (position = '') => (
    <Button
      type="submit"
      style={{visibility: 'hidden'}}
      className={"btn-primary btn-fixed-width " + position} />
  )

  const backButton = () => (
    typeof back === 'boolean' && back
    ? <TrackableButton
        type="submit"
        className='btn-primary btn-fixed-width pull-left'
        page={page}
        user={user}
        text={formatMessage(defaultMessages.clientCommonButtonsBack)}
        onClick={e => dispatch(setPreviousPage(true))}/>
    : dummyButton('pull-left')
  )

  const skipButton = () => (
    typeof skip === 'boolean' && skip
    ? <TrackableButton
        type="submit"
        className='btn-default btn-fixed-width pull-right'
        page={page}
        user={user}
        text={formatMessage(defaultMessages.clientCommonButtonsSkip)}
        onClick={e => dispatch(setNextPage(true))}/>
    : dummyButton()
  )

  const submitButton = () => (
    typeof submitFunc === 'function'
    ? <TrackableButton
        type="submit"
        className='btn-primary btn-fixed-width pull-right'
        style={{marginLeft: '10px'}}
        page={page}
        user={user}
        text={icon()}
        disabled={disableSubmit}
        onClick={submitClick}
        icon={icon}/>
    : dummyButton('pull-right')
  )

  return (
    <div>
      <div className='button-spacer'></div>
      <div className='form-group text-center form-footer'>
        {backButton()}
        {submitButton()}
        {skipButton()}
      </div>
    </div>
  )
}

export default injectIntl(ButtonGroup);
